import { useState } from 'react'
import EmployeeLayout, { type EmployeeSection } from './EmployeeLayout'
import EmployeeHome    from './EmployeeHome'
import EmployeeKanban from './EmployeeKanban'
import EmployeeProfile from './EmployeeProfile'

// ─────────────────────────────────────────────────────────────
// EmployeeDashboard — root page for all employees.
// Simple 3-section workspace: Home overview, Kanban task board,
// and personal profile / performance view.
// ─────────────────────────────────────────────────────────────

function SectionContent({ section, onNav }: { section: EmployeeSection; onNav: (s: EmployeeSection) => void }) {
  switch (section) {
    case 'home':    return <EmployeeHome onNav={onNav} />
    case 'tasks':   return <EmployeeKanban />
    case 'profile': return <EmployeeProfile />
    default:        return <EmployeeHome onNav={onNav} />
  }
}

export default function EmployeeDashboard() {
  const [activeSection, setActiveSection] = useState<EmployeeSection>('home')

  const handleNav = (section: EmployeeSection) => {
    setActiveSection(section)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <EmployeeLayout active={activeSection} onNav={handleNav}>
      <SectionContent section={activeSection} onNav={handleNav} />
    </EmployeeLayout>
  )
}
